
<template>
 <div class="details-component">
   <div class="details-component__header">
     <h1>{{ $tc('accounts.account', 1) }}</h1>
     <div class="details-component__header_right" v-if="$route.params.id">
       <router-link :to="{name: 'edit-account', params: { id: selectedAccountId }}" class="link" >
         {{ $t('common.change') }}&nbsp;<i class="icon icon--arrow"></i>
       </router-link>
       <!--<a href="#" v-on:click="showDeletingConfirmation" class="link link--orange">{{ $t('common.delete') }} <i class="icon icon--cross"></i></a>-->
     </div>
   </div>
   <div class="details-component__content content">
     <div class="content__cell">
       <table class="details-table">
       <tr class="details-table__row">
           <td class="details-table__col details-table__col_label">{{ $t('common.email') }}</td>
           <td class="details-table__col bold">{{ account.email }}</td>
         </tr>
         <tr class="details-table__row">
           <td class="details-table__col details-table__col_label">{{ $t('common.name') }}</td>
           <td class="details-table__col">{{ account.name }}</td>
         </tr>
       </table>
     </div>
    </div>
 </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    account: 'accounts/account/account',
    selectedAccountId: 'accounts/account/id',
  }),
  watch: {
    $route: 'fetchAccount',
  },
  route: {
    canReuse: true,
  },
  created() {
    if (this.$route.params.id) {
      this.fetchAccount();
    }
  },
  methods: {
    fetchAccount() {
      this.$store.dispatch('accounts/account/fetch', { id: this.$route.params.id });
    },
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounts/AccountDetails.vue